export default __webpack_public_path__ + "static/media/csi_partners.8d9cd5d8.svg";